/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Hybrid_RerankInputs */

const en_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid rerank`)
};

const ar_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة ترتيب هجينة`)
};

const bn_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাইব্রিড রির্যাংক`)
};

const de_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid-Neueinstufung`)
};

const es_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio de rango híbrido`)
};

const fr_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclassement hybride`)
};

const pt_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclassificação híbrida`)
};

const zh_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合重新排名`)
};

const tr_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karma sıralama`)
};

const ru_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гибридное изменение рейтинга`)
};

const pl_svchip_hybrid_rerank = /** @type {(inputs: Svchip_Hybrid_RerankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiana rankingu hybrydowego`)
};

/**
* | output |
* | --- |
* | "Hybrid rerank" |
*
* @param {Svchip_Hybrid_RerankInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_hybrid_rerank = /** @type {((inputs?: Svchip_Hybrid_RerankInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Hybrid_RerankInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_hybrid_rerank(inputs)
	if (locale === "bn") return bn_svchip_hybrid_rerank(inputs)
	if (locale === "de") return de_svchip_hybrid_rerank(inputs)
	if (locale === "es") return es_svchip_hybrid_rerank(inputs)
	if (locale === "fr") return fr_svchip_hybrid_rerank(inputs)
	if (locale === "pt") return pt_svchip_hybrid_rerank(inputs)
	if (locale === "zh") return zh_svchip_hybrid_rerank(inputs)
	if (locale === "tr") return tr_svchip_hybrid_rerank(inputs)
	if (locale === "ru") return ru_svchip_hybrid_rerank(inputs)
	if (locale === "pl") return pl_svchip_hybrid_rerank(inputs)
	return en_svchip_hybrid_rerank(inputs)
});